export const TICKET_CONSTANTS = {
  SEARCH: {
    MIN_CHARACTERS: 3,
    DEBOUNCE_MS: 500,
  },
  DATE: {
    FORMAT_LENGTH: 10,
    FORMAT_PATTERN: /^\d{2}\/\d{2}\/\d{4}$/,
  },
  VALIDATION: {
    YEAR_MIN: 1900,
    YEAR_MAX: 2100,
    DAY_MIN: 1,
    DAY_MAX: 31,
    MONTH_MIN: 1,
    MONTH_MAX: 12,
  },
  QUERY: {
    STALE_TIME: 30 * 1000,
    CACHE_TIME: 5 * 60 * 1000,
    REQUEST_TIMEOUT: 35000,
    MAX_RETRIES: 3,
  },
} as const;

export const COLORS = {
  YELLOW_LIGHT: '#FFF3C4',
  PRIMARY: '#E5B611',
  PRIMARY_DARK: '#D3A238',
  ACCENT: '#325A6D',
  SUCCESS: '#10B981',
  WARNING: '#F59E0B',
  ERROR: '#EF4444',
  INFO: '#3B82F6',
} as const;
